module.exports = __webpack_public_path__ + "img/dp-xx-zs2.c6618400.png";